import { render, staticRenderFns } from "./AccountOrdersV2.vue?vue&type=template&id=106cdb68&scoped=true&"
import script from "./AccountOrdersV2.vue?vue&type=script&lang=js&"
export * from "./AccountOrdersV2.vue?vue&type=script&lang=js&"
import style0 from "./AccountOrdersV2.vue?vue&type=style&index=0&id=106cdb68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106cdb68",
  null
  
)

export default component.exports